import React from 'react'
import * as S from './styled'
import { Colors } from '../../colors'
import type { PulsingDotProps } from './types'

export const PulsingDot = ({ color = Colors.G300, label }: PulsingDotProps) => (
  <S.Container $color={color}>
    <S.Dot />
    {label && <S.Label>{label}</S.Label>}
  </S.Container>
)
